import script from "./SearchBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchBar.vue?vue&type=script&setup=true&lang=ts"

import "./SearchBar.vue?vue&type=style&index=0&id=748c07aa&lang=scss"

const __exports__ = script;

export default __exports__